import React, { Suspense, lazy, useState } from "react";
import "./App.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import ProjectModal from "./ProjectModal";
import StarsCanvas from "./canvas/Stars";
import useHashNavigation from "./hooks/useHashNavigation";

// Critical path - Regular imports (eager load)
import Navbar from "./Navbar";
import Home from "./Home";

// Below the fold - Lazy load components with individual Suspense
const About = lazy(() => import("./About"));
const Skills = lazy(() => import("./Skills"));
const Contact = lazy(() => import("./Contact"));
const Footer = lazy(() => import("./Footer"));
const Project = lazy(() => import("./Project"));
const Service = lazy(() => import("./Service"));

function App() {
  const [selectedProject, setSelectedProject] = useState(null);
  
  // Custom hook for hash navigation
  useHashNavigation();

  const openModal = (project) => {
    setSelectedProject(project);
  };

  const closeModal = () => {
    setSelectedProject(null);
  };

  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title>Lyamoudi Ilias</title>
          <meta name="description" content="Ilias Lyamoudi's portfolio website showcases a collection of top software engineering projects, highlighting skills in building dynamic, user-friendly applications using modern technologies." />
          <meta name="keywords" content="Web developer , Porfolio , Software engineer , Lyamoudi Ilias, Lyamoudi, Ilias Lyamoudi, Ilias, web, development, projects, services" />
        </Helmet>
        
        {/* Global Stars Background */}
        <StarsCanvas />
        
        {/* Critical Path - Eager Load */}
        <Navbar onModalClose={closeModal} />
        <Home />
        
        {/* Below the Fold - Lazy Load with individual Suspense for better chunking */}
        <Suspense fallback={<div className="loading-placeholder">Loading About...</div>}>
          <About />
        </Suspense>
        
        <Suspense fallback={<div className="loading-placeholder">Loading Skills...</div>}>
          <Skills />
        </Suspense>
        
        <Suspense fallback={<div className="loading-placeholder">Loading Projects...</div>}>
          <Project onOpenModal={openModal} />
        </Suspense>
        
        <Suspense fallback={<div className="loading-placeholder">Loading Services...</div>}>
          <Service />
        </Suspense>
        
        <Suspense fallback={<div className="loading-placeholder">Loading Contact...</div>}>
          <Contact />
        </Suspense>
        
        <Suspense fallback={<div className="loading-placeholder">Loading Footer...</div>}>
          <Footer />
        </Suspense>
        
        {/* Global Scroll to Top Button */}
        <ScrollToTop />
        
        {/* Global Project Modal - Rendered at App level */}
        {selectedProject && (
          <ProjectModal 
            project={selectedProject} 
            onClose={closeModal} 
          />
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;
